export default "__VITE_ASSET__KagPk1kE__"